export class FileNameHelper {
  static getFileName(fullFileName) {
    return fullFileName.lastIndexOf('.') > -1 ? fullFileName.substr(0, fullFileName.lastIndexOf('.')) : fullFileName;
  }

  static getFileExtension(fullFileName) {
    return fullFileName.indexOf('.') > -1 ? fullFileName.split('.').pop() : '';
  }
}
